import { I18n } from '@calendly/i18n'
import { CheckboxInput } from '@calendly/ui/components/checkbox-input'
import { useSelector } from 'react-redux'

import { allValue, myMeetingsValue, permissionValue } from 'constants/meetings'
import { isObjectLevelPermissionsAvailableSelector } from 'features/object_level_permissions'
import { useScope } from 'hooks/meetings/use_scope'

import { CheckboxFilterLayout } from './filter_layout'
import { OptionWrapper, StyledLabel } from './styles'

export const Role = ({ params, onChange, useColumnLayout = false }) => {
  const isObjectLevelPermissionsAvailable = useSelector(isObjectLevelPermissionsAvailableSelector)
  const { scopeType } = useScope()

  if (!isObjectLevelPermissionsAvailable || scopeType !== 'user') { return null }

  const { host_ids: hostIds } = params

  const onSelect = (value) => {
    // If 'all' is selected, expand to both values first
    let newHostIds = hostIds.includes(allValue)
      ? [myMeetingsValue, permissionValue]
      : [...hostIds]

    // Toggle the clicked value
    if (newHostIds.includes(value)) {
      newHostIds = newHostIds.filter((v) => v !== value)
    } else {
      newHostIds = [...newHostIds, value]
    }

    // If both are selected, collapse to 'all'
    if (newHostIds.length === 2) {
      newHostIds = [allValue]
    }

    onChange({
      ...params,
      host_ids: newHostIds
    })
  }

  return (
    <CheckboxFilterLayout
      label={I18n.t('publisher.meetings.filter_modal.role.permissions')}
      useColumnLayout={useColumnLayout}
    >
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            id="host_role_checkbox_label"
            checked={hostIds.includes(myMeetingsValue) || hostIds.includes(allValue)}
            onChange={() => onSelect(myMeetingsValue)}
          />
          {I18n.t('publisher.meetings.filter_modal.role.my_meetings')}
        </StyledLabel>
      </OptionWrapper>
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            id="non_host_role_checkbox_label"
            checked={hostIds.includes(permissionValue) || hostIds.includes(allValue)}
            onChange={() => onSelect(permissionValue)}
          />
          {I18n.t('publisher.meetings.filter_modal.role.shared')}
        </StyledLabel>
      </OptionWrapper>
    </CheckboxFilterLayout>
  )
}
